export const Placeholder = {
  DAY: 'DD',
  MONTH: 'MM',
  YEAR: 'RRRR',
} as const;
